import dialogApplyVip from './main';

export default {
  install(Vue) {
    Vue.component(dialogApplyVip.name, dialogApplyVip);
  },
};

